export default __webpack_public_path__ + "static/media/shahen.f0ba04ae.png";